import { Modal } from 'antd'
import { Dropdown } from 'components/form/inputs/Dropdown'
import type { UnitEntry } from 'features/assetDatabase/types/assetOverviewTypes'
import { useGetRolodexEntriesByLoadOptions } from 'features/rolodex'
import React, { useMemo, useState } from 'react'
import styled from 'styled-components'
import { DropdownOption } from 'types'

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const entryTypeOptions: DropdownOption[] = [
  { label: 'Asset', value: 'asset' },
  { label: 'PFD', value: 'pfd' },
]

interface AddLinkModalProps {
  isOpen: boolean
  onClose: () => void
  onSave: (link: { entryType: string; entryID: string; siteID: string }) => void
  siteID: string
}

export const AddLinkModal: React.FC<AddLinkModalProps> = ({
  isOpen,
  onClose,
  onSave,
  siteID,
}) => {
  const [selectedEntryType, setSelectedEntryType] = useState<string>('')
  const [entryID, setEntryID] = useState<string>('')

  const { data: unitEntries } = useGetRolodexEntriesByLoadOptions<
    { entry: UnitEntry }[]
  >({
    type: ['unit'],
    tags: { site: siteID },
    limit: 100000,
  })

  const unitOptions = useMemo(
    () =>
      unitEntries
        ?.filter((unit) => unit.entry.data)
        .map((unit) => ({
          label: unit.entry.data.name ?? unit.entry.id,
          value: unit.entry.id,
        })),
    [unitEntries]
  )

  const handleClose = () => {
    setSelectedEntryType('')
    setEntryID('')
    onClose()
  }

  const handleSave = () => {
    if (selectedEntryType && entryID) {
      const newLink = {
        entryType: selectedEntryType,
        entryID: entryID,
        siteID: siteID,
      }
      onSave(newLink)
      handleClose()
    }
  }

  const isSaveDisabled = !selectedEntryType || !entryID

  return (
    <Modal
      title='Add Link to Node'
      open={isOpen}
      onCancel={handleClose}
      onOk={handleSave}
      okText='Save'
      cancelText='Cancel'
      okButtonProps={{ disabled: isSaveDisabled }}>
      <ModalContent>
        <Dropdown
          $label='Entry Type'
          options={entryTypeOptions}
          onValueChange={setSelectedEntryType}
          placeholder='Select entry type'
          defaultValue={selectedEntryType}
        />
        {selectedEntryType === 'asset' && unitOptions && (
          <Dropdown
            $label='Unit'
            options={unitOptions}
            onValueChange={setEntryID}
            placeholder='Select unit'
            defaultValue={entryID}
          />
        )}
      </ModalContent>
    </Modal>
  )
}
